<template>
    <transition
      name="collapse"
      v-on:before-enter="beforeEnter" v-on:enter="enter"
      v-on:before-leave="beforeLeave" v-on:leave="leave"
    >
      <div
        ref="collapse"
        class="transition collapse"
        :class="innerClass"
        v-show="value && (showOnMount || !transitionOnMount)"
      >
        <slot></slot>
      </div>
    </transition>
</template>

<script>
export default {
  name: 'collapse',

  props: {
    transitionOnMount: { type: Boolean, default: true },
    flexibleHeight: { type: Boolean, default: false },
    value: { type: Boolean, default: true },
    innerClass: { type: String, default: '' },
    delayOnEnter: { type: Number, default: 10 },
    delayOnLeave: { type: Number, default: 10 },
  },

  data() {
    return {
      showOnMount: false,
    };
  },

  async created() {
    if (this.transitionOnMount) {
      await this.$nextTick();
      this.showOnMount = true;
    }
  },

  methods: {
    beforeEnter(el) {
      // eslint-disable-next-line no-param-reassign
      el.style.height = '0';
    },
    enter(el) {
      // Add a little delay on enter to prevent buggy opening.
      setTimeout(() => {
        // eslint-disable-next-line no-param-reassign
        el.style.height = `${el.scrollHeight}px`;
      }, this.delayOnEnter);
      // Set height to unset after animating so if height
      // of inner elements change this element will adapt.
      if (this.flexibleHeight) {
        setTimeout(() => {
          // eslint-disable-next-line no-param-reassign
          el.style.height = 'unset';
        }, 250 + this.delayOnEnter);
      }
    },
    beforeLeave(el) {
      // eslint-disable-next-line no-param-reassign
      el.style.height = `${el.scrollHeight}px`;
    },
    leave(el) {
      // Add a little delay on leave to prevent buggy opening.
      setTimeout(() => {
        // eslint-disable-next-line no-param-reassign
        el.style.height = '0';
      }, this.delayOnLeave);
    },
  },
};
</script>

<style>
.collapse {
  overflow: hidden;
}
</style>
